module.exports = __webpack_public_path__ + "static/media/slardar.722e0f79.png";